export default "__VITE_ASSET__C0I9qkwZ__"